import { render } from "./TheTooltip.vue?vue&type=template&id=99f9ea5a&scoped=true&lang=pug"
import script from "./TheTooltip.vue?vue&type=script&lang=js"
export * from "./TheTooltip.vue?vue&type=script&lang=js"

import "./TheTooltip.vue?vue&type=style&index=0&id=99f9ea5a&lang=scss&scoped=true"

import exportComponent from "/builds/fenix/ais-abr/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99f9ea5a"]])

export default __exports__